import { UserPropertyType } from "@gettactic/api";
import { SelectTeams } from "../SelectTeams";
import { cn } from "@gettactic/helpers";
import { useBreakpoint } from "@gettactic/helpers/src/hooks/useBreakpoint";

interface TeamAttendanceFiltersProps {
  teams: string[];
  onTeamsChange: (ids: string[]) => void;
  onSaveFilterData: (type: UserPropertyType, value: string) => void;
  isComponentLoading?: boolean;
  triggerClassName?: string;
  className?: string;
}

export const TeamAttendanceFilters = ({
  teams,
  onTeamsChange,
  isComponentLoading,
  triggerClassName,
  className
}: TeamAttendanceFiltersProps) => {
  const { isBreakpoint } = useBreakpoint();
  const isMd = isBreakpoint("md");
  return (
    <div className="">
      <div className="">
        <SelectTeams
          includeFavs={true}
          teams={teams}
          applyOnClick={isMd}
          onChange={(teamIds: string[] | string) => {
            const teamIdsArray = Array.isArray(teamIds) ? teamIds : [teamIds];
            onTeamsChange(teamIdsArray);
          }}
          className={className}
          disabled={isComponentLoading}
          triggerClassName={cn(
            "mx-0 px-0 py-0 my-0 min-h-0 text-nowrap h-auto",
            triggerClassName
          )}
          closeOnApply={!isMd}
        />
      </div>
    </div>
  );
};
